import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/incentive-actions';
import { IncentiveActions } from '../constants';
import { IIncentive } from 'src/types/incentive';
import { IProvider } from 'src/types/provider';

export interface IncentiveState {
    inProgress: boolean;
    inProgressEntity: boolean;
    authCode: string;
    error: string;
    data: Paginated<IIncentive>;
    dataEntities: {
        list?: any;
    };
    providerPayload: Paginated<Partial<IProvider>>;
    current: IIncentive | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    inProgressEntity: false,
    authCode: '',
    error: '',
    dataEntities: { list: [] },
    providerPayload: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },

    current: null,
    currentFiles: null,
};

export function incentives(state: IncentiveState = initialState, action: Actions | any): IncentiveState {
    switch (action.type) {
        case requestType(IncentiveActions.PERSIST_INCENTIVE):
            return { ...state, error: '', inProgress: true };
        case successType(IncentiveActions.PERSIST_INCENTIVE):
            return { ...state, inProgress: false };
        case failureType(IncentiveActions.PERSIST_INCENTIVE):
            return { ...state, error: action.error, inProgress: false };
        case requestType(IncentiveActions.FETCH_INCENTIVES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(IncentiveActions.FETCH_INCENTIVES):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(IncentiveActions.FETCH_INCENTIVES):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        case requestType(IncentiveActions.FETCH_INCENTIVES_IN_FILE):
            return {
                ...state,
                error: '',
                inProgress: true,
            };
        case successType(IncentiveActions.FETCH_INCENTIVES_IN_FILE):
            return { ...state, inProgress: false };
        case failureType(IncentiveActions.FETCH_INCENTIVES_IN_FILE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(IncentiveActions.FETCH_INCENTIVES_PROVIDERS):
            return {
                ...state,
                inProgress: true,
                providerPayload: { ...state.providerPayload, inProgress: true },
            };
        case successType(IncentiveActions.FETCH_INCENTIVES_PROVIDERS):
            return {
                ...state,
                providerPayload: { ...state.providerPayload, list: Object.values(action.payload), inProgress: false },
                error: '',
                inProgress: false,
            };
        case failureType(IncentiveActions.FETCH_INCENTIVES_PROVIDERS):
            return {
                ...state,
                error: '',
                inProgress: false,
                providerPayload: { ...state.providerPayload, inProgress: false },
            };

        case requestType(IncentiveActions.FETCH_INCENTIVE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(IncentiveActions.FETCH_INCENTIVE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(IncentiveActions.FETCH_INCENTIVE):
            return { ...state, inProgress: false, error: action.error };

        case requestType(IncentiveActions.FETCH_INCENTIVES_ENTITIES):
            return { ...state, inProgressEntity: true, inProgress: true, dataEntities: { list: [] }, error: '' };
        case successType(IncentiveActions.FETCH_INCENTIVES_ENTITIES):
            return {
                ...state,
                inProgressEntity: false,
                inProgress: false,
                dataEntities: { list: action.payload },
            };
        case failureType(IncentiveActions.FETCH_INCENTIVES_ENTITIES):
            return { ...state, inProgressEntity: false, inProgress: false, error: action.error };

        case requestType(IncentiveActions.DELETE_INCENTIVE):
            return { ...state, error: '', inProgress: true };
        case successType(IncentiveActions.DELETE_INCENTIVE):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IIncentive) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(IncentiveActions.DELETE_INCENTIVE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(IncentiveActions.UPDATE_INCENTIVE):
            return { ...state, error: '', inProgress: true };
        case successType(IncentiveActions.UPDATE_INCENTIVE):
            state.data.list.forEach((incentive: IIncentive, k, array) => {
                if (incentive.id === action.payload.id) {
                    array[k] = { ...array[k], status: action.payload.status };
                }
            });
            return {
                ...state,
                data: {
                    ...state.data,
                    list: state.data.list,
                    meta: state.data.meta,
                },
                current: state.current ? { ...state.current, status: action.payload.status } : null,
                inProgress: false,
            };
        case failureType(IncentiveActions.UPDATE_INCENTIVE):
            return {
                ...state,
                error: action.error?.response?.data?.errorMessage ?? 'Unknown error',

                inProgress: false,
            };

        default:
            return state;
    }
}
